var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoalBurned(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #92a5a8;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n        stroke: #62797e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #324e55;\n      }\n\n      .cls-5 {\n        fill: #f96138;\n      }\n\n      .cls-3 {\n        stroke-width: 4px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4,
    y1: 69.6,
    x2: 71.4,
    y2: 69.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.9,36.2l5.4-10.5-.9,6.8h5.4l-5.4,10.5,1.4-6.8h-5.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.9,69.6s.3-15.7,0-20.2,0-14.7,0-14.7h-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.3,34.7h-4.4s.3,10.1,0,14.7c-.3,4.5,0,20.2,0,20.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 37.3,
    y1: 39.5,
    x2: 51.2,
    y2: 39.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.9,31.5s-2.7,1.1-3.6-3,1.5-5.7,1.5-5.7c0,0,3-8.3,8.9-12.7s8.4,1.5,8.4,1.5c0,0,3.1-4.6,7.6.3s-.1,7.7-.1,7.7c0,0,2.8,7.7-3.6,8.3-.6,6.1-11,3.8-11,3.8h-8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.3,69.6s.3-18.1,0-23.4,0-17,0-17h-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.9,29.3h-5.1s.3,11.7,0,17,0,23.4,0,23.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 16.9,
    y1: 34.6,
    x2: 33,
    y2: 34.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.6,26s-2.7-.9-2.4-4.4,3.3-3.8,3.3-3.8c0,0-1.1-5.5,1.8-7.8s6.7-.6,6.7-.6c0,0-.5-4.3,3.9-5.5s6.3,1.9,6.3,1.9c0,0,4.6-3.4,8,.6,3.4,4-.2,7.8-.2,7.8,0,0,3.4,2.9.2,7.6s-6.8,1.1-6.8,1.1c0,0-2.1,5.2-10,3.1.2.2-10.8,0-10.8,0Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoalBurned);
export default __webpack_public_path__ + "static/media/coalBurned.c2cc0d41d770714b8f474c4c61223744.svg";
export { ForwardRef as ReactComponent };